@import "config";

.customSelect {
	width: 100%;

	[class~="ant-select-selector"] {
		border-radius: $border-radius-sm !important;
		border-color: $color-dark-d5 !important;
	}

	[class~="ant-select-selection-placeholder"] {
		color: $color-light-l1 !important;
	}

	&[class~="ant-select-focused"] > div,
	[class~="ant-select-selector"]:hover {
		border-color: $color-secondary-light !important;
		box-shadow: $shadow-level-1 !important;
	}

	&[class~="ant-select-disabled"] > div {
		border-color: $color-dark-d5 !important;
		color: $color-dark-d4 !important;
		background-color: $color-light-l2 !important;

		[class~="ant-select-selection-placeholder"] {
			color: $color-dark-d4 !important;
		}

		&[class~="ant-select-selector"]:hover {
			border-color: $color-dark-d5 !important;
			box-shadow: none !important;
		}
	}
}

.customFooter {
	text-align: right;
	color: $color-light-l5;
	font-size: $font-size-xs;
	padding: $spacing-inline-nano;
	font-weight: $font-weight-bold;
	background-color: $color-primary-pure;
}
